import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router'

import Select from 'components/Select'
import SearchBar from 'components/SearchBar'

import { getAllServiceTypesNames } from 'store/Menus/selectors'
import {
  addRevenueCentersByServiceTypes,
  searchGlobalRevenueCenters,
} from 'store/RevenueCenters/actions'
import { setCurrentPaginationConfig } from 'store/AppState/actions'
import { getSearchGlobalRevenueCenters } from 'store/RevenueCenters/selector'

const ListFilters = () => {
  const allServiceTypes = useSelector(getAllServiceTypesNames)
  const searchGlobalRevenueCentersValue = useSelector(
    getSearchGlobalRevenueCenters
  )
  const dispatch = useDispatch()
  const history = useHistory()

  const setPaginationToDefault = () => {
    const paginationConfig = { screen: 'revenueCenters', page: 1 }

    dispatch(setCurrentPaginationConfig(paginationConfig))
  }

  const handleChangeRevenueCentersSelect = (value) => {
    const filteredValue = allServiceTypes.find(
      (serviceType) => serviceType.uuid === value
    )

    const filteredValueName = filteredValue?.name ?? ''

    const transformedFilteredValue =
      filteredValueName === 'Concessions'
        ? 'Pickup'
        : filteredValueName

    dispatch(
      addRevenueCentersByServiceTypes(transformedFilteredValue)
    )

    setPaginationToDefault()
  }

  const handleSearch = (value) => {
    dispatch(searchGlobalRevenueCenters(value))
  }

  const redirectToAddNew = () => history.push('revenue-centers/new')

  return (
    <div className="revenue-centers-filters">
      <Select
        handleChange={(value) =>
          handleChangeRevenueCentersSelect(value)
        }
        options={allServiceTypes}
        label="All Service Types"
        nameClass="-shorter"
      />
      <SearchBar
        handleSearch={handleSearch}
        searchQuery={searchGlobalRevenueCentersValue}
        setPaginationToDefault={setPaginationToDefault}
      />
      <button
        className="btn new-item"
        type="button"
        onClick={redirectToAddNew}
      >
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

export default ListFilters
